<template>
  <b-modal id="already-member-modal" modal-class="modal-style" ref="modal">
    <template>
      <p class="modal-style-title not-one-row">已經是會員</p>
      <div class="modal-style-content">
        <p class="modal-style-content__mobile">此手機號碼已經是會員囉！</p>
      </div>
    </template>

    <template v-slot:modal-footer>
      <button
        class="custom-btn modal-style-single-btn"
        @click="$bvModal.hide('already-member-modal')"
      >
        確定
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  methods: {}
};
</script>
